import base from './base'; //base urls list
import axios from '../https';//axios instance
const env = base.backend
const funddashboard_api = {    
    // get basic fund info  
    fundInfo(fund_code){   
        return axios.get(`${env}/api/smsf/${fund_code}/retrieve_fundinfo/`);    
    },  
    fundBalance(fund_code){   
        return axios.get(`${env}/api/marketvalue/${fund_code}/retrieve_balance/`);    
    },   
    fundStatus(fund_code){   
        return axios.get(`${env}/api/smsf/${fund_code}/fund_status/`);    
    },    
    fundInvestments(fund_code){
        return axios.get(`${env}/api/investment/${fund_code}/retrieve_fund/`);  
    },
    fundCash(fund_code){
        return axios.get(`${env}/api/smsf/${fund_code}/cash_at_bank/`);  
    },
    fundUnmatched(fund_code){
        return axios.get(`${env}/api/smsf/${fund_code}/unmatched/`);  
    },
    fundMember(fund_code){
        return axios.get(`${env}/api/trustee/${fund_code}/fund_member/`);  
    },
    strategy(fund_code){
        return axios.get(`${env}/api/investment/${fund_code}/strategy/`);  
    },
    fundPension(fund_code){
        return axios.get(`${env}/api/pension/${fund_code}/retrieve_fund/`);  
    },
    fundContribution(fund_code){
        return axios.get(`${env}/api/contribution/${fund_code}/retrieve_fund/`);  
    },
    fundTax(fund_code){
        return axios.get(`${env}/api/smsf/${fund_code}/tax/`);  
    },
    member_benefit_estimate(fund_code){
        return axios.get(`${env}/api/trustee/${fund_code}/member_benefit_estimate/`);  
    },
    reports(report_str){
        return axios.get(`${env}/api/smsf/${report_str}/reports/`);  
    },
    documents(fund_code,params){
        return axios.get(`${env}/api/smsf/${fund_code}/documents/`,{
            params:params
        });  
    },
    download(fund_code,params){
        return axios.get(`${env}/api/smsf/${fund_code}/download/`,{
            params: params
        });  
    },
    bgl_report(fund_code){
        return axios.get(`${env}/api/investment/${fund_code}/bgl_report/`);  

    }
    // outbox(data){
    //     return axios.post(`${env}/api/outbox/`,data:data);    
    // }
    // articleDetail (id, params) {        
    //     return axios.get(`${base.sq}/topic/${id}`, {            
    //         params: params        
    //     });    
    // },
    //
    // login (params) {        
    //     return axios.post(`${base.sq}/accesstoken`, qs.stringify(params));    
    // }
    // .....
}

export default funddashboard_api;